import * as React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import '@/lib/string';

import type { EventElementProps } from './event-element-props.interface';

export const CustomEvent = ({ data }: EventElementProps) => {
  const isAssignmentEvent = ['Entered Assignment Queue', 'Ticket Assignment Failed'].includes(data.type);
  return (
    <div
      id={`CustomEvent-${data.id}`}
      className={classNames('custom-box', isAssignmentEvent && ['hide-important', 'assignment-event'])}
    >
      <div className="container">
        <div className="content">
          <div className={`custom ${data.icon}`}>
            <div className="text-box">
              <div className="type">
                {`${(data.type as string)?.titleize() ?? 'Custom'} Event`}
              </div>
              <div className="preview">{data.body}</div>
              <div className="chat-timestamp">
                {moment(data.sent_at * 1000).format('L [AT] LT')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
